var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('x-dropdown',{attrs:{"items":_vm.itemProps,"nudge-bottom":"40"},scopedSlots:_vm._u([{key:"activator",fn:function(){return [_c('v-icon',{staticClass:"icon icon_size_lg"},[_vm._v("mdi-dots-horizontal")])]},proxy:true},{key:"listItem",fn:function(ref){
var ref_item = ref.item;
var icon = ref_item.icon;
var title = ref_item.title;
var evtName = ref_item.evtName;
var i = ref.i;
return [_c('v-list-item',{key:i,staticClass:"dropdown__item",attrs:{"link":""},on:{"click":function($event){return _vm.propagateCustomEvt(evtName)}}},[_c('v-icon',{staticClass:"dropdown__icon"},[_vm._v(_vm._s(icon))]),_c('span',{staticClass:"secondary--text"},[_vm._v(_vm._s(title))])],1)]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }